module.exports = __webpack_public_path__ + "public/img/header.e915ce46.png";